module.exports = __webpack_public_path__ + "de2b81876c480cbd5c3f80f4457e572f.MP3";